import { updateAnalysisView } from "@actions";
import RevenueGraph from "@components/revenue/RevenueGraph";
import { prettyMoney } from "@helpers/currency";
import { connect } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";
import React from "react";

const AnalysisGraph = (props) => {
  const { graph, graphLoading } = props.analysis;

  const formatter = (value) => (isNaN(value) ? value : prettyMoney(value, 2));

  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: "1em 1em 0em 2em",
      }}
    >
      <RevenueGraph
        tickFormatter={formatter}
        toolTipFormatter={formatter}
        data={graph.data}
        lines={graph.lines}
        symbol={""}
        aspect={4.6}
      />
      <Dimmer inverted active={graphLoading}>
        <Loader active={graphLoading} />
      </Dimmer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    analysis: state.analysisView,
  };
};

export default connect(mapStateToProps, {
  updateAnalysisView,
})(AnalysisGraph);
